// TODO: The Id's are not correctly and have to be updated yet.
export const ENUM_TYPE_IDS = {
    EVENTSTATUS: 740,
    MAINSYSTEMS: 200,
    SUBSYSTEMS: {
        201: 200,
        202: 200,
        203: 200
    }
}
